import { createFileRoute, useParams } from '@tanstack/react-router'

import { FaceListScreen } from '@/components/growers/faces/face-list-screen'
import { useGrower } from '@/hooks/use-growers-query'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/agriculture/growers/$id_/faces/',
)({
    component: GrowerFacesRoutePage,
})

/**
 * Danh sách khuôn mặt của một hộ — surface NHÂN VIÊN.
 *
 * File đặt tên `.index.tsx` chứ không `faces.tsx`: đặt kiểu kia thì nó thành
 * route CHA của `faces.$faceId`, mà route cha không có <Outlet /> nên bấm sang
 * màn thêm/sửa chỉ đổi URL còn nội dung vẫn đứng ở danh sách.
 *
 * Lồng dưới hộ chứ không đứng riêng: cấu hình khuôn mặt là một phần hồ sơ hộ,
 * không có màn "quản lý khuôn mặt" toàn hệ thống.
 */
function GrowerFacesRoutePage() {
    const { id } = useParams({
        from: '/_app/_authed/_sidebar/agriculture/growers/$id_/faces/',
    })
    const { data: grower } = useGrower(id)

    return (
        <FaceListScreen
            growerId={id}
            growerName={grower?.name ?? ''}
            scope="staff"
        />
    )
}
